import { settings } from "../config/settings";

/**
 * Convert a relative media/API file path to an absolute URL.
 * @param {string|null|undefined} url
 * @returns {string|null}
 */
export const resolveAbsoluteUrl = (url) => {
  if (!url) return null;

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  if (url.startsWith("/")) {
    return `${settings.MEDIA_BASE_URL}${url}`;
  }

  return url;
};

/**
 * Resolve attachment file URL (file_url from API or relative file path).
 * @param {{ file_url?: string, file?: string }} attachment
 * @returns {string|null}
 */
export const resolveAttachmentUrl = (attachment) => {
  if (!attachment) return null;
  return resolveAbsoluteUrl(attachment.file_url || attachment.file);
};
